import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const STOCK_RETURN_URL = `${backendUrl}/stockReturn`;

const initialState = {
  isLoading: false,
  error: null,
  returns: [],
  stockReturn: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "stockReturn",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getReturnsSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.returns = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getReturnSuccess(state, action) {
      state.isLoading = false;
      state.stockReturn = action.payload;
    },
    clearReturn(state) {
      state.stockReturn = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getStockReturns({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(STOCK_RETURN_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getReturnsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getStockReturn(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${STOCK_RETURN_URL}/${id}`);
      dispatch(slice.actions.getReturnSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateStockReturn(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${STOCK_RETURN_URL}/${id}`, data);
      dispatch(slice.actions.getReturnSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function assignWarehouseStoreToReturnLine(stockReturnId, lineId, warehouseStoreId) {
  return async () => {
    const response = await axios.patch(
      `${STOCK_RETURN_URL}/${stockReturnId}/lines/${lineId}/warehouse-inventory-store`,
      { warehouseStoreId }
    );
    return response.data;
  };
}

export const { clearReturn } = slice.actions;
